import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-front-desk-register-confirm',
  templateUrl: './front-desk-register-confirm.component.html',
  styleUrls: ['./front-desk-register-confirm.component.scss']
})
export class FrontDeskRegisterConfirmComponent implements OnInit {

  constructor( @Inject(MAT_DIALOG_DATA) public data: any) {
    //console.log(JSON.stringify(this.data))
   }

  ngOnInit() {
  }

}